<template>
  <router-link
    v-if="mobileTestbedActive"
    class="nav-link mobile-nav-tools"
    :to="{ name: `${app}-mobile-tools` }"
    data-test="mobile-nav-tools"
  >
    <x-icon
      icon="swiss-army-knife"
      class="nav-icon"
      width="18px"
      height="18px"
    />
    Tools
  </router-link>
</template>

<script setup lang="ts">
import xIcon from '@/components/shared/x-icon/index.vue'
import { computed } from 'vue'

import { isMobileTestbedActive } from '@/lib/prototyping-flags'
const mobileTestbedActive = computed(() => isMobileTestbedActive())
const app = computed(() => 'fish')
</script>

<style scoped lang="scss">
@use '@/styles/system/_breakpoints.scss';

.mobile-nav-tools {
  display: none;

  @include breakpoints.app-prototyping() {
    display: block;
  }
}
</style>
